import Typography from "@material-ui/core/Typography";
import ManageSubscriptionButton from "src/pages/RootDialogs/ProfileSettings/ManageSubscriptionButton";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import theme from "src/theme";
import { Box } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
}));

interface CostActionDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function CostActionDialog(props: CostActionDialogProps) {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h4" className={classes.headerText}>
        Wait! We may have a lower-priced membership level that suits you...
      </Typography>
      <Typography variant="body1">
        Since we offer a wide range of pricing options and features, there may
        be a better pricing option for you. With our Basic plan, you can
        continue using My Reseller Genie for as little as $9.99 per month.
      </Typography>
      <div style={{ paddingTop: "1rem" }}>
        We encourage you to check out all pricing options before making your
        final decision.
      </div>
      <ManageSubscriptionButton
        style={{ marginTop: "1rem" }}
        label={"Explore Pricing Options"}
      />
      <div style={{ paddingTop: "1rem" }}>
        <Typography>
          <Box component="span" fontWeight="fontWeightMedium">
            Before you click Cancel Subscription,
          </Box>{" "}
          we would love to know what price would change your mind:
        </Typography>
      </div>
      <TextField
        id="filled-basic"
        label="Please Enter a Reason"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default CostActionDialog;
